/**
 * Created by mac on 4/23/21
 */

const Map2dPushes = function () {
    this.accumulated = {};

    this.updateFruits(PUSHES.FRUIT_RIPE);
    this.updateFruits(PUSHES.CASTLE_PRIZE);
    this.updateFruits(PUSHES.MAGIC_PLANT_READY);
    this.updateOrders();
};

Map2dPushes.prototype.destructor = function () {
    Object.keys(this.accumulated).forEach((id) => this.clearUpdate(id));
};

Map2dPushes.prototype.scheduleUpdate = function (id, callback) {
    if (!this.accumulated[id]) {
        this.accumulated[id] = setTimeout(callback, 1000);
    }
};

Map2dPushes.prototype.clearUpdate = function (id) {
    if (this.accumulated[id]) {
        clearTimeout(this.accumulated[id]);
        delete this.accumulated[id];
    }
};

Map2dPushes.prototype.updateBuilt = function () {
    const nextBuilding = this._buildingBuilt();

    PushHelper.sendPush(PUSHES.BUILDING_BUILT, nextBuilding);
};

Map2dPushes.prototype._buildingBuilt = function () {
    const worker = Map2d.currentMap.workers.findLeastBusy(Buildable);
    if (worker) {
        return worker.getTimeLeft();
    }
};

Map2dPushes.prototype.updateChopped = function () {
    const nextTree = this._treeChopped();
    let type = PUSHES.TREE_CHOPPED;

    if (!cleverapps.meta.getSelectedLocation().locationConfig.isMain) {
        type = PUSHES.EXPEDITION_TREE_CHOPPED;
    }

    PushHelper.sendPush(type, nextTree);
};

Map2dPushes.prototype._treeChopped = function () {
    const worker = Map2d.currentMap.workers.findLeastBusy(Mineable);
    if (worker) {
        return worker.getTimeLeft();
    }
};

Map2dPushes.prototype.updateOrders = function () {
    const minCookingTimeLeft = this._orderReady();

    PushHelper.sendPush(PUSHES.ORDER_READY, minCookingTimeLeft);
};

Map2dPushes.prototype._orderReady = function () {
    const customers = Map2d.currentMap.customers.listCustomers().filter((customer) => customer.unit.getType() === "hero");

    let minTime = undefined;
    customers.forEach((customer) => {
        if (customer.getState() === Customer.STATE_COOKING) {
            const timeLeft = customer.getCookingTimeLeft();
            if (minTime === undefined || minTime > timeLeft) {
                minTime = timeLeft;
            }
        }
    });

    return minTime;
};

Map2dPushes.prototype.updateMiniGames = function () {
    this.scheduleUpdate(PUSHES.MINI_GAME_PRIZE.id, () => this._updateMiniGames());
};

Map2dPushes.prototype._updateMiniGames = function () {
    this.clearUpdate(PUSHES.MINI_GAME_PRIZE.id);

    const miniGames = Map2d.currentMap.listAvailableUnits((unit) => unit.findComponent(MiniGame));

    let minTime = undefined;
    miniGames.forEach((miniGameUnit) => {
        const miniGame = miniGameUnit.findComponent(MiniGame);
        const timeLeft = miniGame.timeToReady();
        if (timeLeft > 0) {
            if (minTime === undefined || minTime > timeLeft) {
                minTime = timeLeft;
            }
        }
    });

    PushHelper.sendPush(PUSHES.MINI_GAME_PRIZE, minTime);
};

Map2dPushes.prototype.updateFruits = function (type) {
    this.scheduleUpdate(type.id, () => this._updateFruits(type));
};

Map2dPushes.prototype._updateFruits = function (type) {
    this.clearUpdate(type.id);

    let nextTime;

    Map2d.currentMap.listAvailableUnits().forEach((unit) => {
        const fruit = unit.findComponent(Fruit);
        if (fruit && fruit.localPush === type) {
            const timeLeft = fruit.timeToReady();
            if (timeLeft > 0 && (nextTime === undefined || nextTime > timeLeft)) {
                nextTime = timeLeft;
            }
        }
    });

    PushHelper.sendPush(type, nextTime);
};
